import React from "react";
// import Navbar from "../../components/Navbar";
import Content from "./content";

// import BG from "../../assets/contact/contactBG.png";
// import BGmobile from "../../assets/contact/contactBGMobile.png";

function Contact() {
  // const [isDesktop] = useState(false);
  return (
    <div className="h-screen">
      {/* <div
        className="md:hidden  w-full h-screen flex flex-col justify-start bg-gradient-to-b from-[#2B2E82] to-[#0A0918] bg-cover bg-center"
        style={{
          backgroundImage: `url(${BGmobile})`,
        }}
      >
        <Navbar />
        <Content />
        <Footer />
      </div> */}

      {/* <Navbar /> */}
      <Content />
    </div>
  );
}

export default Contact;
